import React, { Component } from "react";
import { Modal, Table } from '@deere/ux.uxframe-react';
import warningUrl from '@deere/ux.brand-foundations/icons/warning.svg';
import { Link } from 'react-router-dom';

import baseurl from '../../api-properties';

class SupplierInfoTopHeader extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showProsMatchingTableModal: false,
            existingSupplierDetails: []
        }
    };

    componentDidMount() {
        if (this.props.deereView) {
            this.loadExistingSuppliers();
        }
    }

    loadExistingSuppliers = () => {
        let jsonData = this.props.companyInfoObj;
        fetch(baseurl.PROS_SUPPLIER_API_URL + "supllier/getExistingSuppliers", {
            method: "POST",
            body: JSON.stringify(jsonData),
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json"
            }
        }).then(response => {
            if (response.status === 401 || response.status === 403) {
                window.location.href = "/error";
            }
            return response.json();
        })
            .then(data => {
                if (data !== undefined && data !== null && data.length > 0) {
                    this.setState({existingSupplierDetails: data});
                }
            }).catch(error => {
            console.log(error);
        });
    }

    renderTableData() {
        if (this.state.existingSupplierDetails !== null && this.state.existingSupplierDetails.length > 0) {
            return this.state.existingSupplierDetails.map((exSupp) => {
                const {status, supplierNo, supplierName, supplierAddress} = exSupp
                return (
                    <tr key={status}>
                        <td>{status}</td>
                        <td>{supplierNo}</td>
                        <td>{supplierName}</td>
                        <td>{supplierAddress}</td>
                    </tr>
                )
            })
        }
    }

    showProsMatchingTableModal = () => {
        this.setState({showProsMatchingTableModal: true});
    }
    hideProsMatchingTableModal = () => {
        this.setState({showProsMatchingTableModal: false});
    }

    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-md-8 text-xs-center">
                        <label className="uxf-label">Company Name</label>
                        <p className="uxf-label" style={{fontWeight: 'normal'}}>{this.props.companyInfoObj.companyName}</p>
                        <label className="uxf-label">Parent Company Name</label>
                        <p className="uxf-label" style={{fontWeight: 'normal'}}>{this.props.companyInfoObj.parentCoName}</p>
                    </div>
                    <div className="col-md-8 text-xs-center">
                        <label className="uxf-label">Address</label>
                        <p className="uxf-label" style={{fontWeight: 'normal'}}>
                            {this.props.companyInfoObj.address}<br/>
                            {this.props.companyInfoObj.stateName === null || this.props.companyInfoObj.stateName === "" ? "" :
                                <span>{this.props.companyInfoObj.stateName},&nbsp;</span>}{this.props.companyInfoObj.zip}<br/>
                            {this.props.companyInfoObj.countryName}
                        </p>
                    </div>
                    <div className="col-md-8 text-xs-center">
                        <label className="uxf-label">Key Contact</label>
                        <p className="uxf-label" style={{fontWeight: 'normal'}}>
                            {this.props.companyInfoObj.contactName}<br/>
                            {this.props.companyInfoObj.jobTitle}<br/>
                            <a href="#">{this.props.companyInfoObj.emailAddress}</a>
                        </p>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-8 text-xs-center">
                        <label className="uxf-label">WebSite URL</label>
                        <p className="uxf-label" style={{fontWeight: 'normal'}}><a
                            href="#">{this.props.companyInfoObj.websiteUrl}</a></p>
                    </div>
                    <div className="col-md-8 text-xs-center">
                        <label className="uxf-label">Telephone</label>
                        <p className="uxf-label" style={{fontWeight: 'normal'}}>{this.props.companyInfoObj.phone}</p>
                    </div>
                    {this.props.deereView ?
                        <div className="col-md-8 text-xs-center">
                            <label className="uxf-label">Prior Business with John Deere</label>
                            <p className="uxf-label"
                               style={{fontWeight: 'normal'}}>{this.props.companyInfoObj.businessCode === "Y" ? "Yes" : "No"}
                                {this.state.existingSupplierDetails !== null && this.state.existingSupplierDetails.length > 0 ?
                                    <span>
                                        &nbsp;&nbsp;&nbsp;<img src={warningUrl} alt={""} />&nbsp;&nbsp;
                                        <Link style={{color: "red"}} onClick={this.showProsMatchingTableModal} to={"#"}>Potentially Existing Supplier Match!</Link>
                                    </span> : null
                                }
                            </p>
                        </div>
                        : <div className="col-md-8 text-xs-center">
                            <label className="uxf-label">Prior Business with John Deere</label>
                            <p className="uxf-label"
                               style={{fontWeight: 'normal'}}>{this.props.companyInfoObj.businessCode === "Y" ? "Yes" : "No"}
                            </p>
                        </div>
                    }
                </div>
                <div className="row">
                    <div className="col-md-8 text-xs-center">
                        <label className="uxf-label">Created On</label>
                        <p className="uxf-label" style={{fontWeight: 'normal'}}>{this.props.companyInfoObj.createdDate}</p>
                    </div>
                </div>
                <Modal size='lg' show={this.state.showProsMatchingTableModal}>
                    <Modal.Header>
                        <h7 className="modal-title">Potentially Exisiting Supplier Match</h7>
                        <button type="button" className="close" onClick={this.hideProsMatchingTableModal}>&times;</button>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            <p>This Prospective Supplier might already be in our system.</p>
                            <div className="w-100">
                                <Table responsive>
                                    <thead>
                                    <tr>
                                        <th>Status</th>
                                        <th>Supplier Number</th>
                                        <th>Supplier Name</th>
                                        <th>Address</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.renderTableData()}
                                    </tbody>
                                </Table>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>
        )
    }
}
export default SupplierInfoTopHeader;